import React, {useEffect, useRef, useState} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import IntlTelInput from "react-intl-tel-input";

import Config, {IS_QKB_UI} from './../../../config';
import Misc from "../../../misc/misc";
import {changeUserInfo, changeUserInfoErrors} from "../../../actions/actionFunctions";
import {useIsMounted} from "../../../misc/helperHooks";
import {getPreferredCountries} from "../../common/twoFactorAuthView";
import UserFieldErrors from "../../popups/userPopup/userFieldsErrors";
import OnScreenKeyboard from "../../common/OnScreenKeyboard/keyboard";

const replaceDialCode = (dialCode, inputValue) => {
  const dialWithPlus = "+" + dialCode;
  if (dialWithPlus.length > 1) {
    const charLength = dialWithPlus.length;
    if (dialWithPlus === inputValue.slice(0,charLength)) {
      inputValue = inputValue.slice(charLength);
    }
  }
  inputValue = inputValue.split(" ").join("").split("-").join("");
  return inputValue
}

const LookUserPhoneInput = (props) => {

  const {property, userInfo, changeUserInfo, intl, userInfoErrors, changeUserInfoErrors, placeholder, isUserPopup,
    isActive, inputsValidated, fabricatorData, className} = props;
  // const isLowes = fabricatorData.isLowes;

  const inputRef = useRef();
  const [defaultValue, ] = useState(userInfo[property]);
  const [blurred, setBlurred] = useState(false);
  const [focused, setFocused] = useState(false);
  const [wasChanged, setWasChanged] = useState(false);
  const isMounted = useIsMounted();
  const utilsScript = Config.getScriptPath() + "/libphonenumber.js";

  // const handleInputBlur = (isValid, value, _this.selectedCountryData, fullNumber, _this.getExtension(value), e) => { // all input tel props params
  const handleInputBlur = (isValid, inputValue, ...rest) => {

    let restartInput = false;
    setFocused(false);

    const event = rest[3];
    if (event && event.relatedTarget && event.relatedTarget.className.includes("keyboard-container")) { // blur from osk keyboard
      return
    }

    if (!blurred) {
      setBlurred(true);
    }
    const replacedValue = replaceDialCode(userInfo.country.dialCode, inputValue);
    if (replacedValue !== inputValue) {
      inputValue = replacedValue;
      restartInput = true;
    }

    const fullNumber = `+${userInfo.country.dialCode} ${inputValue}`;
    const errors = getValidationErrors(fullNumber, userInfo.country.iso2.toUpperCase());
    // if (!errors.length && !isValid) {
    //   errors.push("assignPopup.errors.phoneIncorrect")
    // }
    if (errors.length) {
      changeUserInfoErrors({
        [property]: errors
      })
    } else if (!errors.length && userInfoErrors[property]) {
      changeUserInfoErrors({
        [property]: errors
      })
    }
    // removed this formatting due to incorrect validation ex.(+447862073603)
    const formattedPhone = errors[property]
      ? Misc.getPhoneFormatted(inputValue, userInfo.country.iso2.toUpperCase())
      : inputValue;
    console.log("handleInputBlur formattedPhone", formattedPhone);
    changeUserInfo({
      [property]: formattedPhone
    });
    if (restartInput && inputRef && inputRef.current && inputRef.current.setInitialState) {
      setTimeout(() => {
        inputRef.current.setFlag(userInfo.country.iso2, true);
        inputRef.current.setNumber(fullNumber);
        // inputRef.current.setInitialState();
      }, 0)
    }
    // console.log("blur number", isValid, inputValue);
  };

  useEffect(() => {
    if (IS_QKB_UI) {
      if (isMounted() && isActive) {
        handleInputBlur(true, userInfo[property]);
      }
    } else if (!inputsValidated) {
      handleInputBlur(true, userInfo[property]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputsValidated]);

  const getValidationErrors = (currentValue, region) => {
    if (fabricatorData.isCaesarStone) {
      return []
    }
    region = region || "US";
    const errors = [];
    if (!currentValue) {
      errors.push("assignPopup.errors.phoneRequired");
      return errors
    }
    if (!Misc.isPhoneNumber(currentValue, region)) {
      errors.push("assignPopup.errors.phoneIncorrect");
    }
    return errors
  }

  const handleInputFocus = () => {
    setFocused(true);
  }

  /**
   * 5 arguments passed to this callback
   * @param a {boolean} // isValid
   * @param b {string} // newNumber
   * @param c {Object} // countryData
   * @param phoneNumber {string} // fullNumber
   * @param forceCarrot {boolean} // isExtension
   */
  const handleChangeNumber = (a, b, c, phoneNumber, forceCarrot = false) => {
    phoneNumber = phoneNumber.replace(/[^0-9\-\(\)\s]/gi, "");
    /*let prefix = `+${c.dialCode}`;
    phoneNumber = phoneNumber.replace(prefix, '');
    if(country !== "auto" && country.dialCode) {
      prefix = `+${country.dialCode}`;
    }
    if (startsWith(phoneNumber, prefix + ' ') || trim(phoneNumber).length == 0) {
      let hasPrefix = phoneNumber.substring(0, prefix.length) == prefix;
      if (hasPrefix) phoneNumber = trim(phoneNumber.substring(prefix.length));
      phoneNumber = `${prefix} ${phoneNumber}`;
    }*/
    if (forceCarrot) {
      const forceCarrotFunc = () => {
        let p = document.getElementById('phone');
        p.selectionStart = phoneNumber.length;
        p.selectionEnd = phoneNumber.length;
      }
      window.setTimeout(forceCarrotFunc, 10);
    }
    if (!c) {
      return
    }
    if ((userInfo.phoneNumber !== phoneNumber) && (userInfo.country.iso2 !== c.iso2) && isMounted()) {
      // console.log("handleChangeNumber formattedPhone", c);
      // console.log("userInfo.phoneNumber", userInfo.phoneNumber);
      // console.log("phoneNumber", phoneNumber);
      changeUserInfo({country: c});
    }
    if (userInfoErrors[property] || blurred || !focused || !wasChanged) {
      const errors = getValidationErrors(`+${c.dialCode} ${b}`, c.iso2.toUpperCase());
      if (!errors.length || blurred) {
        changeUserInfoErrors({
          [property]: errors
        })
      }
    }
    if (!focused || !wasChanged) { // autofill
      const replacedValue = replaceDialCode(c.dialCode, b);
      if (replacedValue !== b) {
        b = replacedValue;
        const fullNumber = `+${c.dialCode} ${b}`;
        inputRef.current.setNumber(fullNumber);
      }
      changeUserInfo({
        [property]: b
      });
      console.log("change number when it is not focused", b, phoneNumber);
    }
    if (!wasChanged) {
      setWasChanged(true);
    }
  };

  const handleChangeFlag = (currentNumber, selectedCountryData) => {
    /*const matches = currentNumber.match(/(\+\d{1,4}\s)/gi);
    currentNumber = currentNumber.replace(/\+\d{1,4}\s/gi, '');

    const numberSplitted = currentNumber.split("+"+selectedCountryData.dialCode);
    const number = numberSplitted[numberSplitted.length - 1] || "";

    currentNumber = (matches && matches.length > 1)
      ? `${matches[1]}${currentNumber}`
      : `+${selectedCountryData.dialCode} ${number}`;*/

    if (!isActive) {
      return // return here because when user came from log in - it was updating userinfo country and was setting empty currentNumber
    }

    let newUserInfo = {};
    if (currentNumber !== userInfo.phoneNumber) {
      newUserInfo.phoneNumber = currentNumber
    }
    if (selectedCountryData && selectedCountryData.iso2) {
      newUserInfo.country = selectedCountryData
    }
    if (Object.keys(newUserInfo).length) {
      // console.log("handleChangeFlag!!", newUserInfo);
      changeUserInfo(newUserInfo);
    }
    if ((userInfoErrors[property] || blurred) && (selectedCountryData && selectedCountryData.iso2)) {
      const fullNumber = `+${selectedCountryData.dialCode} ${currentNumber}`;
      const errors = getValidationErrors(fullNumber, selectedCountryData.iso2.toUpperCase());
      if (!errors.length) {
        changeUserInfoErrors({
          [property]: errors
        })
      }
    }
  };

  const errorsExist = Array.isArray(userInfoErrors[property]) && userInfoErrors[property].length;

  const renderScreenKeyboard = () => {
    if (!document.kvConfig.osk) {
      return null
    }
    const keyboardNumberClick = (value) => {
      // console.log("keyboardNumberChange", value);
      // console.log("inputRef", inputRef);
      if (value && value.includes(".")) { // phone number can't include dots
        return
      }
      changeUserInfo({ // 1) set redux value
        [property]: value
      });
      // handleChangeNumber(true, value, userInfo.country, value, true);  // 2) change flag? not sure if we need this on number click
      if (inputRef && inputRef.current) { // 3) set input value by passing fake event
        inputRef.current.handleInputChange({
          target: {
            selectionStart: value.length,
            target: inputRef.current.tel,
            value,
          }
        });
      }
    }
    return <OnScreenKeyboard inputId="phone"
                             getValue={() => userInfo.phoneNumber}
                             setValue={keyboardNumberClick}
                             onClose={(v) => {
                               if (!blurred) {
                                 handleInputBlur(true, v)
                               }
                             }}
                             left="100%"
                             top="-57px"
                             type="numeric"/>
  }

  const IntlInputComponent = (
    <IntlTelInput inputClassName={IS_QKB_UI
      ? "ui-input ui-input--new ass-field__input intl-tel-input user-popup-fields__item-input" + (errorsExist ? " ui-input--error" : "")
      : "MuiInputBase-input MuiOutlinedInput-input"}
      // containerClassName={isLowes ? "intl-tel__lowes" : "intl-tel-input"}
                  containerClassName={IS_QKB_UI ? "intl-tel-input" : "MuiFormControl-root MuiTextField-root look-input intl-tel-input"}
                  utilsScript={utilsScript}
                  onSelectFlag={handleChangeFlag}
                  preferredCountries={getPreferredCountries()}
                  placeholder={intl.formatMessage({id: IS_QKB_UI && placeholder ? placeholder : "look.inputs.phoneNumber"})}
                  onPhoneNumberChange={handleChangeNumber}
                  onPhoneNumberBlur={handleInputBlur}
                  onPhoneNumberFocus={handleInputFocus}
                  separateDialCode={true}
                  maxLength={16}
                  defaultValue={defaultValue}
                  defaultCountry={userInfo.country.iso2}
                  fieldId="phone"
                  size={IS_QKB_UI ? "" : "small"}
                  ref={inputRef}
    />
  )

  if (IS_QKB_UI) {
    return (
      <div className="ass-field">
        {IntlInputComponent}
        {fabricatorData.isCaesarStone || (isUserPopup && !errorsExist) ? null : <span className="ass-field__required">*</span>}
        <UserFieldErrors property={property}/>
        {renderScreenKeyboard()}
      </div>
    )
  }

  return (
    <div className={"look-block" + (className ? " " + className : "")}>
      <div className={"look-block__phone MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl"
      + (focused ? " Mui-focused" : "") + (errorsExist ? " Mui-error" : "")}>
        {IntlInputComponent}
        <fieldset aria-hidden="true" className="PrivateNotchedOutline-root-1 MuiOutlinedInput-notchedOutline">
          <legend className="PrivateNotchedOutline-legendLabelled-3">
            <span><FormattedMessage id={"look.inputs.phoneNumber"}/>*</span>
          </legend>
        </fieldset>
      </div>
      {errorsExist ? (
        <p className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error Mui-required">
          <FormattedMessage id={userInfoErrors[property][0]}/>
        </p>
      ) : null}
      {renderScreenKeyboard()}
    </div>
  )
};

LookUserPhoneInput.propTypes = {
  property: PropTypes.string.isRequired,
  inputsValidated: PropTypes.bool.isRequired,
  shrink: PropTypes.bool,
  restartPhoneInput: PropTypes.func,
  placeholder: PropTypes.string,
  isUserPopup: PropTypes.bool,
  isActive: PropTypes.bool,
  className: PropTypes.string,
};

const mapStateToProps = (store) => {
  const {userInfo, userInfoErrors} = store.userState;
  return {
    userInfo,
    userInfoErrors,
    fabricatorData: store.fabricatorState
    // assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText
  };
};

const mapDispatchToProps = {
  changeUserInfo,
  changeUserInfoErrors
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookUserPhoneInput)
)
